import styled from "@emotion/styled";

export const StyledForm = styled.form``;
